import { useCallback } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';
import { FormattedMessage } from 'react-intl';
import { useModal } from '../../../../../hooks/use-modal';
import { Button } from 'ui-components/components/button';
import { PromotionalBanner } from '../../../../../components/promotional-banner';
import { AddOnsActionContextProvider } from '../../../add-on-marketplace/add-ons-action-context';
import { UpsellModal } from '../../../../../components/upsell-modal/upsell-modal';
import { UpsellModalContentCodes } from '../../../../../constants/upsell-modal-content-codes';
import { SettingsPageEvents, useTrackRateShopperEvent } from '../../hooks/use-track-rate-shopper-analytic-events';

import messages from '../rate-shopper-page/messages';

export const RateShopperFreemiumBanner = ({ className }) => {
  const { isOpen: isUpsellOpen, open: openUpsell, close: closeUpsell } = useModal();
  const { pathname } = useLocation();

  const trackUpsellModalOpen = useTrackRateShopperEvent(SettingsPageEvents.RATE_SHOPPER_UPSELL_MODAL_OPEN, { location: pathname });

  const onClick = useCallback(() => {
    openUpsell();
    trackUpsellModalOpen();
  }, [openUpsell, trackUpsellModalOpen]);

  return (
    <AddOnsActionContextProvider>
      <PromotionalBanner
        className={className}
        promotionalHeaderMessage={messages.upsellHeader}
        promotionalSubheaderMessage={messages.upsellSubHeader}
      >
        <Button onClick={onClick} theme='promotional'>
          <FormattedMessage {...messages.upsellCTAButtonText} />
        </Button>
      </PromotionalBanner>
      {isUpsellOpen && <UpsellModal onClose={closeUpsell} upsellModalContentCode={UpsellModalContentCodes.ShippingStrategies} />}
    </AddOnsActionContextProvider>
  );
};
